import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'

import { COLORS } from '@elo-kit/constants/general.constants'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlack, eloBlue, eloWhite } = COLORS

// TODO: update with using createUseStyles
const courseBannerStyles = (theme) => {
  const {
    buttonColor,
    courseOverview = {},
    fullWidth,
    lesson = {},
    linkColor,
    isOverview,
    showLessonBanner,
    showOverview,
  } = theme || {}

  const source = isOverview ? courseOverview : lesson

  const { bannerColor, bannerFont, bannerSize, bannerStyle, bannerOpacity = 0 } = source || {}

  const backgroundImageUrl = isOverview ? courseOverview.banner : showLessonBanner && lesson.banner

  return {
    bannerContainer: {
      position: 'relative',
    },
    banner: {
      backgroundImage: getBackgroundImageCss(backgroundImageUrl),
      maxWidth: '100%',
      margin: '0 auto',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: showLessonBanner === false ? '' : '280px',
    },
    bannerOverlay: {
      background: isOverview ? courseOverview.bannerOverlay : showLessonBanner && lesson.bannerOverlay,
      opacity: 1 - bannerOpacity / 100,
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    bannerInfoContainer: {
      margin: `${fullWidth ? '0 20px' : '0 auto'}`,
      maxWidth: `${fullWidth ? 'none' : '1140px'}`,
      padding: '0 10px',
      position: 'relative',
      '@media (max-width: 991px)': {
        margin: '0 auto',
      },
    },
    noImageIcon: {
      fontSize: '200px',
      color: eloWhite,
      position: 'absolute',
      left: 'calc(50% - 100px)',
      top: 'calc(50% - 100px)',
    },
    title: {
      fontSize: `${bannerSize || '60'}px`,
      fontFamily: cleanupFonts(bannerFont) || 'Montserrat Medium',
      fontStyle: bannerStyle,
      fontWeight: bannerStyle,
      color: bannerColor || eloBlack,
      lineHeight: 1,
      paddingTop: isOverview || !showOverview ? '80px' : '15px',
      paddingBottom: '10px',
      wordBreak: 'break-word',
      overflowWrap: 'normal',
      display: 'flex',
      justifyContent: 'space-between',
      overflow: 'inherit',

      '@media (max-width: 991px)': {
        paddingTop: `${isOverview || !showOverview ? '0' : '15px'}`,
      },

      '@media (max-width: 768px)': {
        width: '100%',
        wordBreak: 'initial',
      },

      '& button': {
        margin: '15px 0',
      },

      '& i': {
        marginRight: '15px',
      },
    },
    description: {
      fontSize: '16px',
      fontFamily: cleanupFonts(courseOverview.bannerFont) || 'Montserrat Reg',
      color: cleanupFonts(courseOverview.bannerColor) || eloBlack,
      maxWidth: '500px',
      lineHeight: 1.5,
      paddingBottom: '50px',
      wordBreak: 'break-word',
    },
    pageNavigation: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      paddingTop: '40px',
      fontFamily: cleanupFonts(lesson.bannerFont) || 'Montserrat Reg',
      color: '#9e9e9ee6',
      '& i': {
        padding: '0 20px',
      },
      '& a': {
        color: linkColor || eloBlue,
      },
    },
    withResetNavigation: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
    pageNavigationActiveItem: {
      color: linkColor || eloBlue,
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.8,
      },
    },
    navigationButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',
      minWidth: '100px',
      minHeight: '48px',
      borderRadius: '6px',
      backgroundColor: buttonColor || eloBlue,
      fontSize: '14px',
      fontFamily: cleanupFonts(lesson.bannerFont) || 'Montserrat Medium',
      color: eloWhite,
      border: 'none',
      padding: '0 20px',
      cursor: 'pointer',
      '& .fa-chevron-left': {
        paddingRight: '10px',
      },
      '& .fa-chevron-right': {
        paddingLeft: '10px',
      },
      '&:hover': {
        opacity: 0.8,
      },
      '&:active': {
        opacity: 0.6,
      },
    },
    titleAndBuyBtn: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
      },

      '& div': {
        marginRight: 50,
      },
    },
  }
}

export default courseBannerStyles
